import { BarChartModel } from '../models/chart/bar-chart.model';
import { ChartStylingModel } from '../models/chart/chart-styling.model';

export const /** @type {?} */ BarChartTemplates = {
  defaultTemplate: {
    property: new BarChartModel({
      display: true,
      disable: false,
      orientation: 'vertical',
      grouped: false,
      gradient: false,
      showLegend: true,
      legendPosition: 'right',
      chartAlignment: 'start',
      colorSchemeName: 'forest',
      colorScheme: {
        domain: []
      },
      showXAxis: true,
      showYAxis: true,
      showXAxisLabel: true,
      showYAxisLabel: true,
      xAxisLabel: '',
      yAxisLabel: '',
    }),
    style: new ChartStylingModel({
      barsContainerWidth: '100%',
      barsContainerHeight: '200px'
    })
  }
}
